import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

import { Tooltip } from "@mui/material";

import { defaultButton, defaultDescription, defaultId, defaultName, defaultStatus, defaultStatusMsg, defaultThumbnail, defaultTime, defaultStyle } from "./shared.js";
import { getLanguage } from "../../config/language/language";

// Custom functions for table columns.
const getThumbnail = (props, params) => {
    return params.row?.meta_data?.avatar;
};

const urlTitle = (props, params) => {
    return "Source";
};

const clickUrl = (props, params) => {
    const url = params.row.url;
    window.open(url, "_blank");
};

const disableUrl = (props, params) => {
    const url = params.row.url;
    return !url;
};

// Column definitions.
const name = { ...defaultName, minWidth: 150 };
const description = { ...defaultDescription, minWidth: 200 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus({ queueIsProcessed: true }) };
const statusMsg = { ...defaultStatusMsg };
const resources = {
    ...defaultStyle,
    field: "resource_count",
    headerName: getLanguage().LIBRARY_COLUMN_RESOURCES,
    flex: 0.05,
    minWidth: 70,
    sortable: false,
    filterable: false,
    valueGetter: (params) => params.row.resource_count ?? 0
};
const initialized = {
    ...defaultStyle,
    field: "initialized",
    headerName: getLanguage().LIBRARY_COLUMN_INITIALIZED,
    minWidth: 110,
    sortable: true,
    renderCell: (params) => {
        const ready = params.row.initialized === true;
        const label = ready ? getLanguage().LIBRARY_INITIALIZED_YES : getLanguage().LIBRARY_INITIALIZED_NO;
        const icon = ready ? <CheckIcon fontSize="small" /> : <CloseIcon fontSize="small" />;
        return (
            <Tooltip title={label}>
                <span aria-label={label}>{icon}</span>
            </Tooltip>
        );
    }
};
const thumbnail = (props) => {
    return { ...defaultThumbnail(props, { thumbnail: getThumbnail }), headerName: "Avatar", minWidth: 75, flex: 0.1 };
};
const url = (props) => {
    return {
        ...defaultButton(props, { onClick: clickUrl, disabled: disableUrl, title: urlTitle, endIcon: <OpenInNewIcon />, variant: "outlined" }),
        field: "url",
        headerName: "URL",
        minWidth: 105,
        flex: 0.1
    };
};

// Table columns.
export const columns = (props) => [defaultId, name, description, thumbnail(props), resources, status, initialized, url(props), createdOn, updatedOn, statusMsg];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const libraryColumnVisibility = { initialized: false };

export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
